// import { Link } from "react-router-dom";
// import Footer from "../standartComponent/footer/footer";
// import Header from "../standartComponent/header/header";
// import css from "./like.module.css";
// import ProductToLike from "./productToLike";
// import { useState, useEffect } from "react";

// export default function Like({ setCartCounterC, setLikeCounterC }) {
//   const [forRender, setForRender] = useState(false);
//   const [likedProducts, setLikedProducts] = useState([]);
//   useEffect(() => {
//     // Отримуємо дані з localStorage при завантаженні компоненти
//     const storedLikedProducts =
//       JSON.parse(localStorage.getItem("likedProducts")) || [];
//     setLikedProducts(storedLikedProducts);
//   }, [forRender]);

//   const handleRemove = (uid) => {
//     // Отримуємо дані з localStorage
//     const storedLikedProducts =
//       JSON.parse(localStorage.getItem("likedProducts")) || [];

//     // Фільтруємо масив, видаляючи товар з певним uid
//     const updatedLikedProducts = storedLikedProducts.filter(
//       (product) => product.uid !== uid
//     );

//     // Оновлюємо дані в localStorage
//     localStorage.setItem("likedProducts", JSON.stringify(updatedLikedProducts));

//     // Оновлюємо стан компоненти, якщо потрібно
//     setLikedProducts(updatedLikedProducts);
//     setForRender(!forRender);
//     setLikeCounterC((prev) => prev + 1);
//   };
//   return (
//     <div>
//       <div className={css.blueBlockHead}>
//         <div className={css.blueBlockHeadSmall}>
//           <p className={css.countJoin}>Бажане ({likedProducts.length})</p>
//           <Link to="/" className={css.countJoinNew}>
//             Повернутись на головну
//           </Link>
//         </div>
//       </div>
//       <div className={css.likeProductWrap}>
//         <div className={css.likeProductWrapSmall}>
//           {likedProducts.map((el, index) => {
//             return (
//               <ProductToLike
//                 handleRemove={handleRemove}
//                 key={index}
//                 el={el}
//                 setCartCounterC={setCartCounterC}
//                 setLikeCounterC={setLikeCounterC}
//               />
//             );
//           })}
//         </div>
//       </div>
//     </div>
//   );
// }
import { Link } from "react-router-dom";
import css from "./like.module.css";
import ProductToLike from "./productToLike";
import { useEffect, useState } from "react";

export default function Like({ products, setCartCounterC, setLikeCounterC }) {
  const [likedProducts, setLikedProducts] = useState([]);

  useEffect(() => {
    if (!Array.isArray(products)) {
      setLikedProducts([]);
      return;
    }

    try {
      const storedValue = localStorage.getItem("likedProducts");

      const storedLikedProducts = storedValue ? JSON.parse(storedValue) : [];

      if (!Array.isArray(storedLikedProducts)) {
        setLikedProducts([]);
        localStorage.setItem("likedProducts", JSON.stringify([]));
        return;
      }

      /*
       * products із App.js уже містить тільки товари,
       * у яких productVisible === true або "true".
       */
      const visibleProductsMap = new Map(
        products
          .filter((product) => product?.uid)
          .map((product) => [product.uid, product]),
      );

      /*
       * Беремо товари з бажаного та перевіряємо,
       * чи вони досі є серед видимих товарів.
       */
      const filteredLikedProducts = storedLikedProducts
        .map((storedProduct) => {
          const uid =
            typeof storedProduct === "string"
              ? storedProduct
              : storedProduct?.uid;

          if (!uid) return null;

          return visibleProductsMap.get(uid) || null;
        })
        .filter(Boolean);

      setLikedProducts(filteredLikedProducts);

      /*
       * Видаляємо приховані та видалені товари
       * також із localStorage.
       */
      if (filteredLikedProducts.length !== storedLikedProducts.length) {
        localStorage.setItem(
          "likedProducts",
          JSON.stringify(filteredLikedProducts),
        );

        setLikeCounterC((previousValue) => previousValue + 1);
      }
    } catch (error) {
      console.error("Помилка завантаження бажаних товарів:", error);

      setLikedProducts([]);
    }
  }, [products, setLikeCounterC]);

  const handleRemove = (uid) => {
    if (!uid) return;

    const updatedLikedProducts = likedProducts.filter(
      (product) => product.uid !== uid,
    );

    localStorage.setItem("likedProducts", JSON.stringify(updatedLikedProducts));

    setLikedProducts(updatedLikedProducts);
    setLikeCounterC((previousValue) => previousValue + 1);
  };

  return (
    <div>
      <div className={css.blueBlockHead}>
        <div className={css.blueBlockHeadSmall}>
          <p className={css.countJoin}>Бажане ({likedProducts.length})</p>

          <Link to="/" className={css.countJoinNew}>
            Повернутись на головну
          </Link>
        </div>
      </div>

      <div className={css.likeProductWrap}>
        <div className={css.likeProductWrapSmall}>
          {likedProducts.length > 0 ? (
            likedProducts.map((product) => (
              <ProductToLike
                key={product.uid}
                handleRemove={handleRemove}
                el={product}
                setCartCounterC={setCartCounterC}
                setLikeCounterC={setLikeCounterC}
              />
            ))
          ) : (
            <p>У списку бажаного поки немає товарів.</p>
          )}
        </div>
      </div>
    </div>
  );
}
